import styled from 'styled-components';
import Modal from 'antd/lib/modal/Modal';

export const StyledModal = styled(Modal)``;
